<template>
  <div class="event-view-reply">
    <v-row id="reply"
           class="event-view-reply__write"
    >
      <v-col cols="9">
        <v-text-field v-model="replyContent" placeholder="댓글을 입력해 주세요."
                      height="96"
                      outlined hide-details
                      @keyup.enter="addReply"
                      @focus="checkLogin"
        />
      </v-col>

      <v-col cols="3">
        <v-btn color="#949494"
               height="96"
               block dark
               :loading="loading"
               @click="addReply"
        >
          등록
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="replySort">
      <v-col cols="12">
        <button class="replySort__btn"
                :class="{ 'active': isIdSorted, 'asc': sortOption === 'id,asc', 'desc': sortOption === 'id,desc' }"
                @click="updateSortOption('id')"
        >
          최신순
        </button>
        <button class="replySort__btn"
                :class="{ 'active': isLikeSorted, 'asc': sortOption === 'like,asc', 'desc': sortOption === 'like,desc' }"
                @click="updateSortOption('like')"
        >
          좋아요순
        </button>
      </v-col>
    </v-row>
    <v-row v-for="(data) in replyData" :key="data.brdRplyDtlId" class="full-width-button__row">
      <v-col cols="12" class="full-width-button__column full-width-button__column--has-contents">
        <v-btn class="full-width-button full-width-button--no-link full-width-button--contents"
               text block
        >
          <div class="full-width-button__title full-width-button__title--has-date">
            <div class="full-width-button__reg-wrapper">
              <span v-if="data.email"
                    class="full-width-button__reg-id"
              >
                {{ data.email }}
              </span>

              <span class="full-width-button__reg-date">
                {{ data.brdRplyRegDtm }}
              </span>

              <span class="full-width-button__reg-reply">
                {{ data.dispOrdNo || 99999 | numberFormat }}
                <span>번째 댓글</span>
              </span>
            </div>
            <div class="full-width-button__board-title">
              {{ data.brdRplyCtnt }}
            </div>
            <div class="full-width-button__reg-favorite">
              <v-btn icon
                     class="button-with-countText"
                     :ripple="false"
                     @click="changeFavoriteReply(data)"
              >
                <v-icon :color="data.isLiked ? '#FF67A9' : '#AEAEAE'"
                        size="40"
                >
                  $favoriteOn
                </v-icon>
              </v-btn>
              <span class="button-with-count__favorite-count reply">{{ data.brdRplyLikeCnt | numberFormat }}</span>
            </div>
            <div v-if="data.email && data.isMine" class="full-width-button__button-wrapper">
              <v-btn height="50" color="secondary"
                     @click="deleteReply(data.brdRplyDtlId)"
              >
                삭제
              </v-btn>
              <!--              <v-btn height="50" class="ml-2" color="primary">-->
              <!--                수정-->
              <!--              </v-btn>-->
            </div>
          </div>
        </v-btn>
      </v-col>
    </v-row>

    <v-sheet v-if="page < totalPage" class="list__more">
      <v-btn height="50"
             text
             @click="getMore"
      >
        More
      </v-btn>
    </v-sheet>
    <dialog-confirm v-model="showReply"
                    :dialog-title="'안내'"
                    :dialog-text="`댓글 등록을 하려면 로그인이 필요합니다.<br />로그인 페이지로 이동하시겠습니까?`"
                    :button-names="['아니요','네']"
                    @confirm-callback="showReply = false"
                    @confirm-cancel-callback="confirmReplyCancelCallback"
    />
  </div>
</template>

<script>

import { get } from 'vuex-pathify';
import moment from 'moment';
import numberFormat from "@/assets/filters/numberFormat";
import DialogConfirm from "@/components/common/dialogs/DialogConfirm.vue";

export default {
  name: 'EventViewReply',
  components: {DialogConfirm},
  filters: {
    numberFormat,
  },
  props: {
    brdPostId: { type: [String, Number], default: '' },
  },
  data: () => ({
    replyData: [],
    page: 1,
    totalPage: 1,
    replyContent: '',
    loading: false,
    isSubmitting: false,
    likeLoading: false,
    sortOption:'id,desc',
    showReply: false,
  }),
  computed: {
    custId: get('app/custId'),
    computedApiUrl () {
      return `/v2/board/event/post/${this.brdPostId}/reply`;
    },
    computedPage () {
      return this.page;
    },
    computedSort () {
      return this.sortOption;
    },
    computedTotalReply () {
      return this.totalReply;
    },
    computedTotalView () {
      return this.totalView;
    },
    isIdSorted() {
      return this.sortOption.includes('id');
    },
    isLikeSorted() {
      return this.sortOption.includes('like');
    },
  },
  mounted () {
    this.getReply();
  },
  methods: {
    getMore () {
      if (this.page < this.totalPage) {
        this.page++;
        this.getReply();
      }
    },
    getReply () {
      this.$axios.get(this.computedApiUrl, {
          params: {
            page: this.computedPage,
            sort: this.computedSort
          },
        },
      ).then(response => {
          let apiResponse = response.data.data?.content || [];
          this.totalPage = response.data.data?.totalPages || 1;

          apiResponse = apiResponse.map(item => {
            return {
              brdPostId: item.brdPostId,
              brdRplyCtnt: item.brdRplyCtnt,
              email: item.brdRplyRegrEmail,
              brdRplyDtlId: item.brdRplyDtlId,
              brdRplyRegDtm: moment(item.brdRplyRegDtm).format('YYYY-MM-DD'),
              brdRplyRegrId: item.brdRplyRegrId,
              useYn: item.useYn,
              brdRplyLikeCnt:item.brdRplyLikeCnt || 0,
              isLiked:item.isLiked,
              dispOrdNo:item.dispOrdNo,
              isMine:item.isMine,
            };
          });

          if (this.page === 1) {
            this.replyData = apiResponse;
          } else {
            this.replyData.push(...apiResponse);
          }
        this.moveReply();
        },
      );
    },
    addReply () {
      if (this.isSubmitting) {
        this.$dialog.message.error('댓글연속 작성은 불가능합니다. 잠시 후 시도해주세요.', { timeout: 1000 });
        return;
      }
      this.loading = true;
      this.$axios.post(`v2/board/event/post/${this.brdPostId}/reply`, {
          brdPostId: this.brdPostId,
          brdRplyCtnt: this.replyContent,
        },
      ).then(() => {
        this.isSubmitting = true;
        this.loading = false;
          // console.log(response);
        },
      ).catch(error => {
        console.log(error);
        this.loading = false;
      }).finally(() => {
        this.loading = false;
        this.replyContent = '';
        this.page = 1;
        this.getReply();
        this.addReplyCount(1);
        setTimeout(() => {
          this.isSubmitting = false;
        }, 10000);
      });
    },
    deleteReply (brdRplyDtlId) {
      // console.log(brdRplyDtlId);

      this.$dialog.confirm({
        title: '삭제 확인',
        text: '삭제 하시겠습니까?',
        actions: [
          { text: '취소', key: 'N', color: 'secondary' },
          { text: '확인', key: 'Y', color: 'primary' },
        ],
      }).then(res => {
        if (res === 'Y') {
          this.$axios.delete(`/v2/board/event/post/${this.brdPostId}/reply/${brdRplyDtlId}`).then(() => {
              // console.log(response);
            },
          ).catch(error => {
            console.log(error);
          }).finally(() => {
            this.$dialog.message.success('댓글이 삭제되었습니다.');
            this.replyContent = '';
            this.page = 1;
            this.getReply();
            // this.addReplyCount(-1); 댓글을 삭제해도, 총 댓글수는 줄어들지 않으므로 주석처리
          });
        }
      });

    },
    moveReply () {
      if ('reply' in this.$route.query) {
        this.$vuetify.goTo('#reply',{
          duration: 1000,
          offset: 0,
        });
      }
    },
    changeFavoriteReply (data) {
      if (this.favorLoading) {
        return;
      }

      this.favorLoading = true;
      this.$axios.put(`/v2/replies/${data.brdRplyDtlId}/likes`)
        .then(response => {
          if (response.data.code === 'SUCCESS') {
            data.isLiked = !data.isLiked;
            if (data.isLiked) {
              // '좋아요' 추가
              data.brdRplyLikeCnt += 1;
            } else {
              // '좋아요' 제거
              data.brdRplyLikeCnt -= 1;
            }
            this.favorLoading = false;
          }
        });
    },
    updateSortOption(sortType) {
      this.page = 1;
      if (sortType === 'id') {
        this.sortOption = this.sortOption === 'id,desc' ? 'id,asc' : 'id,desc';
        this.getReply();
      } else if (sortType === 'like') {
        this.sortOption = this.sortOption === 'like,desc' ? 'like,asc' : 'like,desc';
        this.getReply();
      }
      // 여기서 API 호출 또는 다른 상태 업데이트 로직을 추가할 수 있습니다.
    },
    checkLogin() {
      if (!this.custId) {
        this.showReply = true;
        this.$nextTick(() => {
          this.$el.querySelector('input').blur();
        });
      }
    },
    confirmReplyCancelCallback () {
      this.showReply = false;
      this.$router.push({ name: 'login', query: { redirect: this.$route?.fullPath }, });
    },
    addReplyCount (count) {
      this.$emit('count-reply', count);
    },
  },
};
</script>

<style scoped>

</style>